"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaFilters = void 0;

var actions = _interopRequireWildcard(require("../actions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  population: 0,
  resetPopulation: false,
  shareOfAudience: 0,
  resetShareOfAudience: false,
  shareOfAttribute: 0,
  resetShareOfAttribute: false,
  index: 0,
  resetIndex: false
};

var mediaFilters = function mediaFilters( // $FlowFixMe
state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.SET_MEDIA_POPULATION:
      return _extends({}, state, {
        resetPopulation: false,
        population: action.payload
      });

    case actions.RESET_MEDIA_POPULATION:
      return _extends({}, state, {
        resetPopulation: true,
        population: 0
      });

    case actions.SET_MEDIA_SHARE_OF_AUDIENCE:
      return _extends({}, state, {
        resetShareOfAudience: false,
        shareOfAudience: action.payload
      });

    case actions.RESET_MEDIA_SHARE_OF_AUDIENCE:
      return _extends({}, state, {
        resetShareOfAudience: true,
        shareOfAudience: 0
      });

    case actions.SET_MEDIA_SHARE_OF_ATTRIBUTE:
      return _extends({}, state, {
        resetShareOfAttribute: false,
        shareOfAttribute: action.payload
      });

    case actions.RESET_MEDIA_SHARE_OF_ATTRIBUTE:
      return _extends({}, state, {
        resetShareOfAttribute: true,
        shareOfAttribute: 0
      });

    case actions.SET_MEDIA_INDEX:
      return _extends({}, state, {
        resetIndex: false,
        index: action.payload
      });

    case actions.RESET_MEDIA_INDEX:
      return _extends({}, state, {
        resetIndex: true,
        index: 0
      });

    default:
      return state;
  }
};

exports.mediaFilters = mediaFilters;